import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';
import { useMutation, useQueryClient } from 'react-query';
import { enqueueSnackbar } from 'notistack';
import axiosClient from '../../../../../../../../lib/axios';
import LoadingFechamento from '../../LoadingFechamento';

export default function DialogFinalizarFechamento({ open, id, onClose, handleFinalizado }: DialogFinalizarFechamentoProps) {

    const queryClient = useQueryClient();

    const { mutate: realizarFechamento, isLoading } = useMutation({
        mutationKey: 'realizar-fechamento',
        mutationFn: () => axiosClient.post(`/financeiro/conta-corrente-consumo/finalizar-fechamento/${id}`, null, {
            timeout: 600000
        }),
        onError: (error) => {
            console.error(error);
            enqueueSnackbar("Erro ao finalizar fechamento", { variant: "error" })
        },
        onSuccess: ({ data }) => {
            enqueueSnackbar("O fechamento está em andamento, aguarde alguns instantes", { variant: "success" })
            queryClient.invalidateQueries([`pesquisar-ultimos-fechamentos`])
            queryClient.invalidateQueries([`pesquisar-proximos-fechamentos`])
            handleFinalizado()
        }
    });

    const handleConfirmar = () => {
        realizarFechamento();
    }

    return (
        <Dialog open={open}>
            <DialogTitle>Finalizar fechamento</DialogTitle>
            <DialogContent>

                {isLoading ? <LoadingFechamento id={id} label="Finalizando fechamento" /> : (
                    <DialogContentText>
                        Deseja realmente finalizar o fechamento?
                    </DialogContentText>
                )}
            </DialogContent>
            {
                !isLoading && (
                    <DialogActions>
                        <Button variant="outlined" onClick={onClose}>Cancelar</Button>
                        <Button
                            variant="contained"
                            onClick={handleConfirmar}
                        >
                            Finalizar
                        </Button>
                    </DialogActions>
                )
            }
        </Dialog>
    )
}

interface DialogFinalizarFechamentoProps {
    open: boolean;
    id: number;
    onClose: () => void;
    handleFinalizado: () => void;
}
